import { actions } from '@/modules/DemandeIntervention/store/actions';
import { getters } from '@/modules/DemandeIntervention/store/getters';
import { mutations } from '@/modules/DemandeIntervention/store/mutations';
import { state } from '@/modules/DemandeIntervention/store/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { SuiviDemandeInterventionState } from './state';

const module: Module<SuiviDemandeInterventionState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

export default module;
export type { SuiviDemandeInterventionState };
